type LoadinSkeleton = {
  key: number
}

export const loadingSkeletonKeys: LoadinSkeleton[] = [{ key: 1 }, { key: 2 }, { key: 3 }]
